import React from 'react';
import {
    Box,
    Typography,
    Paper
} from '@mui/material';

import { useTranslation } from "react-i18next";


const Toolbox = ({ onDeleteDrop }) => {
    const [t] = useTranslation('crm')

    const handleDeleteDrop = (e) => {
        e.preventDefault();
        if (onDeleteDrop) onDeleteDrop(e);
    };

    return (
        <Paper sx={{ p: 2, width: 300, minHeight: '100%', bgcolor: '#fff' ,height: '100%' }}>
            <Typography variant="h6">{t('Toolbox')}</Typography>

            <Box mt={2}>
                <Box
                    sx={{ p: 1, bgcolor: '#d1e7dd', borderRadius: 1, border: '1px dashed #0f5132', textAlign: 'center', cursor: 'grab' }}
                    draggable
                    onDragStart={(e) => {
                        e.dataTransfer.setData('type', 'new-row');
                    }}
                >
                    {t('Add a row')}
                </Box>
            </Box>

            <Box mt={2}>
                <Box
                    sx={{ p: 1, bgcolor: '#cfe2ff', borderRadius: 1, border: '1px dashed #084298', textAlign: 'center', cursor: 'grab' }}
                    draggable
                    onDragStart={(e) => {
                        e.dataTransfer.setData('type', 'new-section');
                    }}
                >
                    {t('Add a section')}
                </Box>
            </Box>

            <Box
                onDragOver={(e) => e.preventDefault()}
                onDrop={handleDeleteDrop}
                mt={4}
                sx={{ border: '2px dashed red', p: 2, textAlign: 'center', color: 'red', bgcolor: '#ffe6e6' }}
            >
                {t('Grab here to delete')}
            </Box>
        </Paper>
    );
};

export default Toolbox